import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Lets a feature route rendered inside the dashboard shell (e.g. the document
 * editor) ask the shell to collapse its sidebar for a focused, full-width view
 * and later restore the user's saved preference.
 *
 * The service only broadcasts intent — it never writes the persisted
 * `sidebarCollapsed` preference — so a temporary in-view collapse does not
 * overwrite the user's global choice. `restore` tells the shell to fall back to
 * whatever the user last saved.
 */
@Injectable({ providedIn: 'root' })
export class SidebarService {
  private request = new Subject<'collapse' | 'restore'>();
  readonly request$ = this.request.asObservable();

  /** Request the shell to collapse the sidebar (without persisting it). */
  collapse(): void {
    this.request.next('collapse');
  }

  /** Request the shell to revert to the user's saved sidebar preference. */
  restore(): void {
    this.request.next('restore');
  }
}
